import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import ViewKanban from "@mui/icons-material/ViewKanban";
import Schedule from "@material-ui/icons/Schedule";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CakeIcon from "@material-ui/icons/Cake";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import BusinessIcon from "@material-ui/icons/Business";
import {
  AllInclusive,
  AttachFile,
  Dashboard,
  Description,
  DeviceHubOutlined,
  GridOn,
  PhonelinkSetup,
} from "@material-ui/icons";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { ShapeLine, Webhook } from "@mui/icons-material";

import useCompanySettings from "../hooks/useSettings/companySettings";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100%",
    padding: "10px 10px 16px",
    background:
      theme.mode === "light"
        ? "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)"
        : "linear-gradient(180deg, #111827 0%, #0f172a 100%)",
  },

  section: {
    marginTop: 14,
    "&:first-child": {
      marginTop: 4,
    },
  },

  sectionTitle: {
    padding: "8px 12px 6px",
    lineHeight: 1,
    color: theme.mode === "light" ? "#94a3b8" : "#94a3b8",
    fontSize: 11,
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },

  collapsedSectionSpacer: {
    height: 10,
  },

  listItem: {
    position: "relative",
    minHeight: 44,
    width: "100%",
    margin: "2px 0",
    padding: "6px 10px",
    borderRadius: 12,
    color: theme.mode === "light" ? "#475569" : "#cbd5e1",
    transition: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
    "&:hover": {
      backgroundColor:
        theme.mode === "light"
          ? `${theme.palette.primary.main}0f`
          : "rgba(255, 255, 255, 0.06)",
      color: theme.palette.primary.main,
    },
    "&:hover $iconHoverActive": {
      backgroundColor: `${theme.palette.primary.main}18`,
      color: theme.palette.primary.main,
    },
  },

  listItemCollapsed: {
    justifyContent: "center",
    padding: "8px 6px",
    minHeight: 46,
  },

  listItemText: {
    color: "inherit",
    fontSize: 13,
    fontWeight: 650,
    lineHeight: 1.25,
    "& .MuiTypography-root": {
      fontFamily: "'Inter', 'Roboto', sans-serif",
    }
  },

  listItemIcon: {
    minWidth: 42,
  },

  listItemIconCollapsed: {
    minWidth: "auto",
  },

  iconHoverActive: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 12,
    height: 32,
    width: 32,
    backgroundColor:
      theme.mode === "light"
        ? "#f1f5f9"
        : "rgba(255, 255, 255, 0.08)",
    color: theme.mode === "light" ? "#64748b" : "#cbd5e1",
    transition: "all 180ms ease",
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    }
  },

  // Badge melhorado mas mantendo funcionalidade
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: "#ef4444",
      color: "#fff",
      fontSize: "0.75rem",
      fontWeight: 600,
      animation: "$pulse 2s infinite",
    }
  },

  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.7,
    }
  },

  // Melhorias para submenus mantendo estrutura original
  submenuContainer: {
    margin: "2px 0 8px 12px",
    padding: "4px 0 4px 10px",
    borderLeft: `1px solid ${theme.mode === "light" ? "#e2e8f0" : "rgba(255, 255, 255, 0.12)"}`,
  },

  // Tooltip melhorado
  customTooltip: {
    backgroundColor: theme.mode === "light" ? "#1e293b" : "#374151",
    color: "#fff",
    fontSize: "0.875rem",
    fontWeight: 500,
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    "& .MuiTooltip-arrow": {
      color: theme.mode === "light" ? "#1e293b" : "#374151",
    }
  },

  versionContainer: {
    textAlign: "center",
    padding: "14px 6px 2px",
    color: theme.mode === "light" ? "#94a3b8" : "#94a3b8",
    fontSize: 11,
    fontWeight: 700,
  },

  expandIcon: {
    color: theme.mode === "light" ? "#94a3b8" : "#94a3b8",
    fontSize: "1.1rem",
    transition: "transform 180ms ease, color 180ms ease",
    "&.expanded": {
      transform: "rotate(180deg)",
      color: theme.palette.primary.main,
    }
  },

  menuContainer: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.mode === "light"
        ? "rgba(0, 0, 0, 0.1)"
        : "rgba(255, 255, 255, 0.1)",
      borderRadius: "3px",
      "&:hover": {
        background: theme.mode === "light"
          ? "rgba(0, 0, 0, 0.2)"
          : "rgba(255, 255, 255, 0.2)",
      }
    },
  },

  activeItem: {
    backgroundColor:
      theme.mode === "light"
        ? `${theme.palette.primary.main}14`
        : "rgba(255, 255, 255, 0.08)",
    color: theme.palette.primary.main,
    "&:before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 9,
      bottom: 9,
      width: 3,
      borderRadius: "0 999px 999px 0",
      backgroundColor: theme.palette.primary.main,
    },
    "& $iconHoverActive": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      boxShadow: `0 8px 18px ${theme.palette.primary.main}28`,
    },
    "& $listItemText": {
      color: "inherit",
      fontWeight: 700,
    }
  }
}));

function ListItemLink(props) {
  const { icon, primary, to, tooltip, showBadge, nested } = props;
  const classes = useStyles();
  const { activeMenu } = useActiveMenu();
  const location = useLocation();
  const isActive = activeMenu === to || location.pathname === to;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  const ConditionalTooltip = ({ children, tooltipEnabled }) =>
    tooltipEnabled ? (
      <Tooltip title={primary} placement="right">
        {children}
      </Tooltip>
    ) : (
      children
    );

  return (
    <ConditionalTooltip tooltipEnabled={!!tooltip}>
      <li>
        <ListItem
          button
          component={renderLink}
          className={`${classes.listItem} ${tooltip ? classes.listItemCollapsed : ""} ${isActive ? classes.activeItem : ""}`}
          style={nested && !tooltip ? { minHeight: 38, paddingTop: 4, paddingBottom: 4 } : undefined}
        >
          {icon ? (
            <ListItemIcon className={`${classes.listItemIcon} ${tooltip ? classes.listItemIconCollapsed : ""}`}>
              {showBadge ? (
                <Badge
                  badgeContent="!"
                  color="error"
                  overlap="circular"
                  className={classes.badge}
                >
                  <Avatar
                    className={classes.iconHoverActive}
                  >
                    {icon}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  className={classes.iconHoverActive}
                >
                  {icon}
                </Avatar>
              )}
            </ListItemIcon>
          ) : null}
          {!tooltip && (
            <ListItemText
              primary={
                <Typography className={classes.listItemText}>
                  {primary}
                </Typography>
              }
            />
          )}
        </ListItem>
      </li>
    </ConditionalTooltip>
  );
}

function MenuSection({ title, collapsed, children }) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      {collapsed ? (
        <div className={classes.collapsedSectionSpacer} />
      ) : (
        <ListSubheader disableSticky disableGutters className={classes.sectionTitle}>
          {title}
        </ListSubheader>
      )}
      {children}
    </div>
  );
}

function NavGroup({
  active,
  collapsed,
  icon,
  open,
  onClick,
  primary,
  children,
}) {
  const classes = useStyles();

  const groupItem = (
    <ListItem
      button
      onClick={onClick}
      className={`${classes.listItem} ${collapsed ? classes.listItemCollapsed : ""} ${active ? classes.activeItem : ""}`}
    >
      <ListItemIcon className={`${classes.listItemIcon} ${collapsed ? classes.listItemIconCollapsed : ""}`}>
        <Avatar className={classes.iconHoverActive}>{icon}</Avatar>
      </ListItemIcon>
      {!collapsed && (
        <>
          <ListItemText
            primary={
              <Typography className={classes.listItemText}>
                {primary}
              </Typography>
            }
          />
          {open ? (
            <ExpandLessIcon className={`${classes.expandIcon} expanded`} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )}
        </>
      )}
    </ListItem>
  );

  return (
    <>
      {collapsed ? (
        <Tooltip title={primary} placement="right">
          {groupItem}
        </Tooltip>
      ) : (
        groupItem
      )}
      {!collapsed && (
        <Collapse in={open} timeout={180} unmountOnExit>
          <List dense component="div" disablePadding className={classes.submenuContainer}>
            {children}
          </List>
        </Collapse>
      )}
    </>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose }) => {
  const classes = useStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);

  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openDashboardSubmenu, setOpenDashboardSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  // novas features
  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [version, setVersion] = useState(false);
  const { list } = useHelps(); // INSERIR
  const [hasHelps, setHasHelps] = useState(false);

  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);

  const { get: getSetting } = useCompanySettings();
  const [showWallets, setShowWallets] = useState(false);

  const isFlowbuilderRouteActive =
    location.pathname.startsWith("/phrase-lists") ||
    location.pathname.startsWith("/flowbuilders");

  useEffect(() => {
    // INSERIR ESSE EFFECT INTEIRO
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const setting = await getSetting(
          {
            "column": "DirectTicketsToWallets"
          }
        );

        setShowWallets(setting.DirectTicketsToWallets);

      } catch (err) {
        toastError(err);
      }
    }

    fetchSettings();
  }, [setShowWallets]);

  const isManagementActive =
    location.pathname === "/" ||
    location.pathname.startsWith("/reports") ||
    location.pathname.startsWith("/moments");

  const isCampaignRouteActive =
    location.pathname === "/campaigns" ||
    location.pathname.startsWith("/contact-lists") ||
    location.pathname.startsWith("/campaigns-config");

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  const { getPlanCompany } = usePlans();

  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id && socket && typeof socket.on === 'function') {
      const companyId = user.companyId;

      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      const eventName = `company-${companyId}-chat`;
      console.log('Registrando listener para:', eventName);

      socket.on(eventName, onCompanyChatMainListItems);

      return () => {
        if (socket && typeof socket.off === 'function') {
          console.log('Removendo listener para:', eventName);
          socket.off(eventName, onCompanyChatMainListItems);
        }
      };
    }
  }, [socket, user.id, user.companyId]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  // useEffect(() => {
  //   if (localStorage.getItem("cshow")) {
  //     setShowCampaigns(true);
  //   }
  // }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className={classes.root} onClick={drawerClose}>
      <MenuSection title="Atendimento" collapsed={collapsed}>
        <ListItemLink
          to="/tickets"
          primary={i18n.t("mainDrawer.listItems.tickets")}
          icon={<WhatsAppIcon />}
          tooltip={collapsed}
        />

        {showWavoipCall && (
          <ListItemLink
            to="/call-historicals"
            primary={i18n.t("mainDrawer.listItems.callHistorical")}
            icon={<HistoryToggleOffIcon />}
            tooltip={collapsed}
          />
        )}

        <ListItemLink
          to="/quick-messages"
          primary={i18n.t("mainDrawer.listItems.quickMessages")}
          icon={<FlashOnIcon />}
          tooltip={collapsed}
        />

        {showInternalChat && (
          <ListItemLink
            to="/chats"
            primary={i18n.t("mainDrawer.listItems.chats")}
            icon={
              <Badge color="secondary" variant="dot" invisible={invisible}>
                <ForumIcon />
              </Badge>
            }
            tooltip={collapsed}
          />
        )}
      </MenuSection>

      <MenuSection title="Relacionamento" collapsed={collapsed}>
        {user.showContacts === "enabled" && (
          <ListItemLink
            to="/contacts"
            primary={i18n.t("mainDrawer.listItems.contacts")}
            icon={<ContactPhoneOutlinedIcon />}
            tooltip={collapsed}
          />
        )}

        {showKanban && (
          <ListItemLink
            to="/kanban"
            primary={i18n.t("mainDrawer.listItems.kanban")}
            icon={<ViewKanban />}
            tooltip={collapsed}
          />
        )}

        {showSchedules && (
          <ListItemLink
            to="/schedules"
            primary={i18n.t("mainDrawer.listItems.schedules")}
            icon={<Schedule />}
            tooltip={collapsed}
          />
        )}

        <ListItemLink
          to="/tags"
          primary={i18n.t("mainDrawer.listItems.tags")}
          icon={<LocalOfferIcon />}
          tooltip={collapsed}
        />

        <Can
          role={user.profile}
          perform="dashboard:view"
          yes={() => (
            <ListItemLink
              to="/birthday-settings"
              primary={i18n.t("mainDrawer.listItems.birthdaySettings")}
              icon={<CakeIcon />}
              tooltip={collapsed}
            />
          )}
        />
      </MenuSection>

      <MenuSection title="Automação" collapsed={collapsed}>
        {user?.showCampaign === "enabled" && showCampaigns && (
          <NavGroup
            active={isCampaignRouteActive}
            collapsed={collapsed}
            icon={<EventAvailableIcon />}
            open={openCampaignSubmenu}
            onClick={() => setOpenCampaignSubmenu((prev) => !prev)}
            primary={i18n.t("mainDrawer.listItems.campaigns")}
          >
            <ListItemLink
              nested
              to="/campaigns"
              primary={i18n.t("campaigns.subMenus.list")}
              icon={<ListIcon />}
            />
            <ListItemLink
              nested
              to="/contact-lists"
              primary={i18n.t("campaigns.subMenus.listContacts")}
              icon={<PeopleIcon />}
            />
            <ListItemLink
              nested
              to="/campaigns-config"
              primary={i18n.t("campaigns.subMenus.settings")}
              icon={<SettingsOutlinedIcon />}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  nested
                  to="/files"
                  primary={i18n.t("mainDrawer.listItems.files")}
                  icon={<AttachFile />}
                />
              )}
            />
          </NavGroup>
        )}

        {user.showFlow === "enabled" && (
          <NavGroup
            active={isFlowbuilderRouteActive}
            collapsed={collapsed}
            icon={<Webhook />}
            open={openFlowSubmenu}
            onClick={() => setOpenFlowSubmenu((prev) => !prev)}
            primary={i18n.t("Flowbuilder")}
          >
            <ListItemLink
              nested
              to="/phrase-lists"
              primary="Fluxo de Campanha"
              icon={<EventAvailableIcon />}
            />
            <ListItemLink
              nested
              to="/flowbuilders"
              primary="Fluxo de conversa"
              icon={<ShapeLine />}
            />
          </NavGroup>
        )}

        <Can
          role={user.profile}
          perform="dashboard:view"
          yes={() => (
            <>
              {showOpenAi && (
                <ListItemLink
                  to="/prompts"
                  primary={i18n.t("mainDrawer.listItems.prompts")}
                  icon={<AllInclusive />}
                  tooltip={collapsed}
                />
              )}
              {showIntegrations && (
                <ListItemLink
                  to="/queue-integration"
                  primary={i18n.t("mainDrawer.listItems.queueIntegration")}
                  icon={<DeviceHubOutlined />}
                  tooltip={collapsed}
                />
              )}
              {showExternalApi && (
                <ListItemLink
                  to="/messages-api"
                  primary={i18n.t("mainDrawer.listItems.messagesAPI")}
                  icon={<CodeRoundedIcon />}
                  tooltip={collapsed}
                />
              )}
            </>
          )}
        />
      </MenuSection>

      <MenuSection title="Administração" collapsed={collapsed}>
      <Can
        role={
          (user.profile === "user" && user.showDashboard === "enabled") ||
            user.allowRealTime === "enabled"
            ? "admin"
            : user.profile
        }
        perform={"drawer-admin-items:view"}
        yes={() => (
          <NavGroup
            active={isManagementActive}
            collapsed={collapsed}
            icon={<Dashboard />}
            open={openDashboardSubmenu}
            onClick={() => setOpenDashboardSubmenu((prev) => !prev)}
            primary={i18n.t("mainDrawer.listItems.management")}
          >
            <Can
              role={
                user.profile === "user" && user.showDashboard === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <>
                  <ListItemLink
                    nested
                    to="/"
                    primary="Dashboard"
                    icon={<DashboardOutlinedIcon />}
                  />
                  <ListItemLink
                    nested
                    to="/reports"
                    primary={i18n.t("mainDrawer.listItems.reports")}
                    icon={<Description />}
                  />
                </>
              )}
            />
            <Can
              role={
                user.profile === "user" && user.allowRealTime === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  nested
                  to="/moments"
                  primary={i18n.t("mainDrawer.listItems.chatsTempoReal")}
                  icon={<GridOn />}
                />
              )}
            />
            {user.profile === "admin" && showWallets && (
              <ListItemLink
                nested
                to="/wallets"
                primary={i18n.t("mainDrawer.listItems.wallets")}
                icon={<AccountBalanceWalletIcon />}
              />
            )}
          </NavGroup>
        )}
      />

      <Can
        role={
          user.profile === "user" && user.allowConnections === "enabled"
            ? "admin"
            : user.profile
        }
        perform="dashboard:view"
        yes={() => (
          <>
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/users"
                  primary={i18n.t("mainDrawer.listItems.users")}
                  icon={<PeopleAltOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />
            {user.super && (
              <ListItemLink
                to="/companies"
                primary={i18n.t("mainDrawer.listItems.companies")}
                icon={<BusinessIcon />}
                tooltip={collapsed}
              />
            )}
            <Can
              role={
                user.profile === "user" && user.allowConnections === "enabled"
                  ? "admin"
                  : user.profile
              }
              perform={"drawer-admin-items:view"}
              yes={() => (
                <ListItemLink
                  to="/connections"
                  primary={i18n.t("mainDrawer.listItems.connections")}
                  icon={<SyncAltIcon />}
                  showBadge={connectionWarning}
                  tooltip={collapsed}
                />
              )}
            />
            {user.super && (
              <ListItemLink
                to="/allConnections"
                primary={i18n.t("mainDrawer.listItems.allConnections")}
                icon={<PhonelinkSetup />}
                tooltip={collapsed}
              />
            )}
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/queues"
                  primary={i18n.t("mainDrawer.listItems.queues")}
                  icon={<AccountTreeOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/financeiro"
                  primary={i18n.t("mainDrawer.listItems.financeiro")}
                  icon={<LocalAtmIcon />}
                  tooltip={collapsed}
                />
              )}
            />
            <Can
              role={user.profile}
              perform="dashboard:view"
              yes={() => (
                <ListItemLink
                  to="/settings"
                  primary={i18n.t("mainDrawer.listItems.settings")}
                  icon={<SettingsOutlinedIcon />}
                  tooltip={collapsed}
                />
              )}
            />
            {user.super && (
              <ListItemLink
                to="/announcements"
                primary={i18n.t("mainDrawer.listItems.annoucements")}
                icon={<AnnouncementIcon />}
                tooltip={collapsed}
              />
            )}
            {hasHelps && (
              <ListItemLink
                to="/helps"
                primary={i18n.t("mainDrawer.listItems.helps")}
                icon={<HelpOutlineIcon />}
                tooltip={collapsed}
              />
            )}
          </>
        )}
      />
      </MenuSection>

      {!collapsed && version && (
        <Typography className={classes.versionContainer}>
          {`${version}`}
        </Typography>
      )}
    </div>
  );
};

export default MainListItems;
